import { useContext, useEffect, useState } from "react"
import { SongPageContext } from "./SongVersionPageContainer"
import { getSongVersionColor } from "../../shared/utils/browse"
import { openProInformationModal } from "../../../../../javascript/services/modal"
import { renderWaveform } from "../../shared/utils/drawWaveform"

const SongVersionDetails = () => {
  const { sv, svPlaySerializer } = useContext(SongPageContext)

  const handleProButtonClick = (e) => {
    openProInformationModal(sv.id)
    //Emit a custom Google Analytics event to track use of PRO info button
    window.ga("send", "event", "Button Clicks", "PRO Button Click", "PRO Info Button")
  }
  useEffect(() => {
    if (!svPlaySerializer) return
    const { id } = JSON.parse(svPlaySerializer)
    const canvas = document.getElementById("static-waveform")
    const style = getComputedStyle(canvas)
    const color = style.getPropertyValue("--waveform-color")?.trim()
    renderWaveform(canvas, id, { color })
   
  }, [svPlaySerializer])
  

  if (sv) {
    return (
      <article className="details contain" aria-label="Song details">
        <div className="song-version-details">
          <div>
            <h3>Instruments</h3>
            <p>
              {sv.instruments && sv.instruments.map((instrument, index) => (
                <span key={instrument}>
                  <a href={`/browse?instruments=${instrument}`}>{instrument}</a>
                  {index < sv.instruments.length - 1 && ", "}
                </span>
              ))}
            </p>
          </div>
          <div>
            <h3>Mood</h3>
            <p>
              {sv.keyword_list && sv.keyword_list.map((mood, index) => (
                <span key={mood}>
                  <a href={`/browse?moods=${mood}`}>{`${mood}`}</a>
                  {index < sv.keyword_list.length - 1 && ", "}
                </span>
              ))}
            </p>
          </div>
          <div>
            <h3>Waveform</h3>

            <canvas id="static-waveform" width="479px" data-color/>

          </div>
        </div>
      </article>
    )
  } else {
    return <></>
  }
}
export default SongVersionDetails
